import { ProductCardType } from '../api/queries/useProducts';

const sortAsc = (arr: number[]) => arr.sort((a, b) => a - b);

const quantile = (arr: number[], q: number) => {
  const sorted = sortAsc(arr);
  const pos = (sorted.length - 1) * q;
  const base = Math.floor(pos);
  const rest = pos - base;
  if (sorted[base + 1] !== undefined) {
    return sorted[base] + rest * (sorted[base + 1] - sorted[base]);
  } else {
    return sorted[base];
  }
};

function ceil100(num: number) {
  return Math.ceil(num / 100) * 100;
}

export const getPercentiles = (list: ProductCardType[]) => {
  const prices = list.map(
    (e) => e.priceOverwrite?.milesAmount ?? e.price.milesAmount,
  );

  const maxs = Array.from(
    new Set([
      ceil100(quantile(prices, 0.1)),
      ceil100(quantile(prices, 0.25)),
      ceil100(quantile(prices, 0.5)),
    ]),
  );

  return [...maxs.filter((e) => e).map((e) => ({ max: e }))];
};
